import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Normaliza e concatena várias entradas `sx` numa única lista que o MUI aceita.
 *
 * Substitui o padrão repetido `Array.isArray(sx) ? sx : sx ? [sx] : []` espalhado
 * pelos componentes. Entradas falsy (`false`/`null`/`undefined`) são descartadas,
 * o que permite passar estilos condicionais inline:
 *
 * ```ts
 * sx={mergeSx(scrollable && scrollViewportSx(theme), userSx)}
 * ```
 */
export function mergeSx<T extends object = Theme>(
  ...entries: Array<SxProps<T> | false | null | undefined>
): SxProps<T> {
  return entries.flatMap((entry) =>
    entry ? (Array.isArray(entry) ? entry : [entry]) : []
  ) as SxProps<T>;
}
